<template>
  <SoPageWithHeader
    title="Bugs & Incidents"
    :dark-header-bg-color="true"
    icon="bug xlg"
  >
    <IssueListTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import headerBg from "@/assets/customer-search-header-bg.png"
  import headerBgDark from "@/assets/customer-search-header-bg-dark.png"
  import IssueListTable from "@/views/issues/components/IssueListTable.vue"

  export default defineComponent({
    components: {
      IssueListTable,
      SoPageWithHeader,
    },
    data() {
      return {
        headerBg,
        headerBgDark,
      }
    },
  })
</script>
